import { injectIntl, IntlShape } from 'react-intl';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { ConnectionTemplatesPresentation } from './connection-templates.presentation';
import { ConnectionTemplatesVM } from './connection-templates.viewmodel';
import { connectedBlueprintsVM } from '../blueprints.context';

export type ContainerProps = {
    accountId: number;
};

const ConnectionTemplatesContainer = injectIntl(withViewModel(
    ConnectionTemplatesPresentation,
    ({ accountId, intl }: ContainerProps & { intl: IntlShape }) => {
        const connectionTemplatesVM = new ConnectionTemplatesVM(accountId, intl);

        connectionTemplatesVM.initialize();

        return connectionTemplatesVM;
    },
    props => [ props.accountId ]
));

export const ConnectionTemplates = connectedBlueprintsVM<ContainerProps>(
    ConnectionTemplatesContainer,
    vm => ({
        accountId: vm.getAccountId()
    })
);
